
export default {
    name: 'BaseAddress',

    props: {
        companyName: {
            type: String,
            default: '',
        },
        firstName: {
            type: String,
            default: '',
        },
        lastName: {
            type: String,
            default: '',
        },
        street: {
            type: String,
            default: '',
        },
        postalCode: {
            type: String,
            default: '',
        },
        houseNumber: {
            type: String,
            default: '',
        },
        city: {
            type: String,
            default: '',
        },
        country: {
            type: String,
            default: '',
        },

        isInline: {
            type: Boolean,
            default: false,
        },
    },
}
